import {Component, HostListener, Inject, OnInit, Optional} from '@angular/core';
import {Persona} from "../../Admin/models/persona";
import {ApiRestService} from "../../Admin/_service/api-rest.service";
import {ApiPathsService} from "../../api-paths.service";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import {DynamicCrudService} from "../_services/dynamic-crud.service";




export interface FilterList {
  name: string;
  iconHtml?: string;
  Campi: {name: string, iconHtml?: string, func?: (x,component: DropdownDropdownFilterComponent, filter: FilterList)=>void, onClear?: (x,component: DropdownDropdownFilterComponent)=>void, active?: boolean}[];
  onClear?: (x,component: DropdownDropdownFilterComponent)=>void;
  active?: boolean;
}

@Component({
  selector: 'app-dropdown-dropdown-filter',
  templateUrl: './dropdown-dropdown-filter.component.html',
  styleUrls: ['./dropdown-dropdown-filter.component.css']
})
export class DropdownDropdownFilterComponent  {

  FilterList: FilterList[] = [
    {name: 'TEST 1', Campi: [
        {name: 'Campione 1', func: (x,component)=>{}, onClear: (x,component)=>{}},
        {name: 'Campione 2', func: (x,component)=>{}, onClear: (x,component)=>{}},
        {name: 'Campione 3', func: (x,component)=>{}, onClear: (x,component)=>{}}
      ], active: false}
  ];

  constructor (
    @Optional() @Inject('FilterList') public filterList: FilterList[]

  ) {
    this.FilterList = filterList ?? this.FilterList;
  }


  opened = false;

  activeMenu: string = null;

  filters: any = {
    priority: null,
    status: null,
    startDate: null,
    deadline: null
  };


  toggleMenu(event: MouseEvent): void {
    event.stopPropagation();

    this.opened = !this.opened;

    if (!this.opened) {
      this.activeMenu = null;
    }
  }


  activeMenuChanged(x): void {
    this.FilterList.forEach(filter => {
      filter.active = filter.name === x.name;
    });
  }






  clearFilters(): void {
    this.FilterList.forEach(filter => {
      filter.active = false;
      if(filter.onClear)
      filter.onClear(filter, this);
    });
  }



  @HostListener('document:click')
  closeMenu(): void {

    if (this.opened) {
      this.opened = false;
      this.activeMenu = null;
    }
  }

}
